import { useState, useCallback } from 'react';

export const useWhatsappMessageFileUpload = () => {

    const [error, setError] = useState(null);
    const validate = useCallback((file) => {
        if (!file) {
            return {
                isValid: false,
                error: 'File is required'
            };
        }
        const ext = file.name.split('.').pop()?.toLowerCase();
        const sizeInMB = file.size / (1024 * 1024);
        const imageExts = ['jpg', 'jpeg', 'png'];
        const videoExts = ['mp4', '3gp'];
        const docExts = [
            'pdf',
            'doc',
            'docx',
            'xls',
            'xlsx',
            'ppt',
            'pptx',
            'txt',
            'csv'
        ];
        if (imageExts.includes(ext)) {
            if (sizeInMB > 5) {
                return {
                    isValid: false,
                    error: 'Image must be less than 5MB'
                };
            }
            return {
                isValid: true,
                mediaType: 'IMAGE'
            };
        }
        if (videoExts.includes(ext)) {
            if (sizeInMB > 16) {
                return {
                    isValid: false,
                    error: 'Video must be less than 16MB'
                };
            }
            return {
                isValid: true,
                mediaType: 'VIDEO'
            };
        }
        if (docExts.includes(ext)) {
            if (sizeInMB > 100) {
                return {
                    isValid: false,
                    error: 'Document must be less than 100MB'
                };
            }
            return {
                isValid: true,
                mediaType: 'DOCUMENT'
            };
        }
        return {
            isValid: false,
            error: 'Unsupported file type'
        };

    }, []);

    return {
        validate,
        error
    };
};